const OverFourAssetsTemplate = ({ item, onOpenPopUp }) => (
  <div className="p-8">
    <div className="flex gap-4">
      {new Array(4).fill(null).map((value, index) => (
        <div
          className="overflow-hidden flex cursor-pointer hover:opacity-80"
          onClick={onOpenPopUp}
        >
          <img src={item.assets[index]} alt="" className="object-cover h-96" />
        </div>
      ))}
    </div>

    {item.assets.length > 5 && (
      <div className="flex gap-4 pt-4">
        <div className="flex-1 flex justify-center items-center">
          <p className="text-center whitespace-pre-line">{Array.isArray(item.description) && item.description.length >= 2 && item.description[1]}</p>
        </div>
        <div className="flex-1 flex gap-4">
          <div
            className="overflow-hidden flex cursor-pointer hover:opacity-80"
            onClick={onOpenPopUp}
          >
            <img src={item.assets[4]} alt="" className="object-cover h-96" />
          </div>
          <div
            className="overflow-hidden flex cursor-pointer hover:opacity-80"
            onClick={onOpenPopUp}
          >
            <img src={item.assets[5]} alt="" className="object-cover h-96" />
          </div>
        </div>
      </div>
    )}

    {item.assets.length > 7 && (
      <div className="flex gap-4 pt-4">
        <div
          className="overflow-hidden flex flex-1 cursor-pointer hover:opacity-80"
          onClick={onOpenPopUp}
        >
          <img
            src={item.assets[6]}
            alt=""
            className="object-cover h-96 w-full"
          />
        </div>
        <div className="flex-1 flex justify-center items-center">
          <p className="text-center whitespace-pre-line">{Array.isArray(item.description) && item.description.length >= 3 && item.description[2]}</p>
        </div>
      </div>
    )}

    {item.assets.length > 8 && (
      <div className="flex gap-4 pt-4">
        <div
          className="overflow-hidden flex flex-1 cursor-pointer hover:opacity-80"
          onClick={onOpenPopUp}
        >
          <img
            src={item.assets[7]}
            alt=""
            className="object-cover h-96 w-full"
          />
        </div>
        <div
          className="overflow-hidden flex flex-1 cursor-pointer hover:opacity-80"
          onClick={onOpenPopUp}
        >
          <img
            src={item.assets[8]}
            alt=""
            className="object-cover h-96 w-full"
          />
        </div>
      </div>
    )}
  </div>
);

export default OverFourAssetsTemplate;
